/**
 * Navigation configuration for the Intl Orders Portal.
 *
 * Single source of truth for the top-nav items. Kept declarative — the
 * optional `requiredRole` is read by the sole consumption site (Layout.tsx,
 * which builds the `navigation` prop shared by both desktop and mobile nav)
 * so a partner without that role never sees the item, without desktop-
 * navigation.tsx / mobile-menu.tsx needing any role awareness of their own.
 */

export interface IntlNavItem {
  name: string;
  path: string;
  requiredRole?: string;
}

export const INTL_NAV_ITEMS: IntlNavItem[] = [
  { name: "Orders", path: "/orders" },
  { name: "Stock", path: "/stock" },
  { name: "Reports", path: "/reports", requiredRole: "admin" },
  { name: "Admin", path: "/admin", requiredRole: "admin" },
];
